import shopifySparkGenericDefaults from '../shopify-spark-generic/config.js';

const isVehicleLanding = !!window.Convermax.config?.isVehicleLanding;
const vehicleLandingPageView = window.Convermax.config?.vehicleLandingPageView ?? 'products';

export default {
  includes: ['shopify-spark-generic'],
  ...shopifySparkGenericDefaults,
  Widgets: [
    ...shopifySparkGenericDefaults.Widgets.filter(
      (w) => !['HeaderVehicleWidget', 'CategoryPageCategoriesGrid'].includes(w.name),
    ),
    {
      name: 'FilterSearchBox',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        firstChildOf: '#cm-ymm',
        class: 'cm_vehicle-widget__home-container halo-section-background-gray',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters &&
        shopifySparkGenericDefaults.fitmentSearch.baseFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
      useSearchableDropdown: true,
      isAlwaysColumnLayout: true,
      isAlwaysActive: true,
      autoOpenDropdowns: 'next',
    },
    {
      name: 'CategoryPageCategoriesGrid',
      type: 'FacetTiles',
      location: '#cm-category-grid-list',
      template: 'facetTiles/subtitles',
      visibleIf: () =>
        (!isVehicleLanding || vehicleLandingPageView === 'products') &&
        window.location.pathname !== '/collections/vendors',
      view: 'grid',
      facetField: 'category',
      excludeFieldPreselection: window.Convermax.config?.showTopLevelCategories ? 'collection_ids' : null,
      useFilterMode: window.Convermax.config?.useTilesFilterMode,
    },
  ],
};
